import React from 'react';
import CategorySelector from './CategorySelector';
import AttributeManager from './AttributeManager';
import ToggleField from './ToggleField';
import InputField from '../Form/InputField'
import Heading3 from "../Basic/Heading3";
import {toPersianNumbers} from "../../utils/toPersianNumbers";

const ProductBasicInfo = ({ productData, setProductData, categoryAttributes, setCategoryAttributes }) => {
  const handleInputChange = (field, value) => {
    setProductData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleToggleChange = (fieldKey, value) => {
      setProductData(prev => ({
        ...prev,
        [fieldKey]: value
      }));
    };

  const UNIT_CHOICES = [
    { value: 'count', label: 'تعداد' },
    { value: 'package', label: 'بسته' },
    { value: 'weight', label: 'کیلو گرم' },
    { value: 'length', label: 'متر' },
    { value: 'area', label: 'متر مربع' },
    { value: 'litr', label: 'لیتر' },
    { value: 'volume', label: 'متر مکعب' },
  ];

  return (

      <div className="space-y-6">
          {/* نام و دسته → دو ستونه */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* نام محصول */}
              <div>
                  <InputField
                      label={'نام کالا'}
                      name={'ProductName'}
                      value={productData.name}
                      placeholder={'نام کالا را وارد کنید'}
                      onChange={(e) => handleInputChange('name', e.target.value)}
                  />
              </div>
              <div>
                  <InputField
                      label={'برند'}
                      name={'Brand'}
                      value={productData.brand}
                      placeholder={'برند کالا را وارد کنید'}
                      onChange={(e) => handleInputChange('brand', e.target.value)}
                  />
              </div>

              {/* دسته محصول */}
              <div>
                  <label className="block text-sm font-medium mb-2">دسته کالا</label>
                  <CategorySelector
                      setProductData = {setProductData}
                      selectedCategory={productData.category}
                      onCategoryChange={(categoryId) => {
                          setProductData(prev => ({
                              ...prev,
                              category: categoryId
                          }));
                      }}
                  />
              </div>
          </div>

          {/* مشخصه‌ها (همیشه تمام عرض باید باشد) */}
          {productData.category && (
              <AttributeManager
                  category={productData.category}
                  productData={productData}
                  setProductData={setProductData}
                  categoryAttributes={categoryAttributes}
                  setCategoryAttributes={setCategoryAttributes}
              />
          )}

          {/* قیمت و موجودی → دو ستونه */}
          <Heading3 text={'ویژگی‌های تکمیلی کالا'}/>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
              <div>
                  <InputField
                      label={'عرض (سانتی متر)'}
                      name={'ProductWidth'}
                      type={'number'}
                      value={productData.width ? Number(productData.width) : ''}
                      placeholder={'عرض کالا را وارد کنید'}
                      onChange={(e) => handleInputChange('width', e.target.value)}
                  />
              </div>

              <div>
                  <InputField
                      label={'طول (سانتی متر)'}
                      name={'ProductLength'}
                      type={'number'}
                      value={productData.length ? Number(productData.length) : ''}
                      placeholder={'طول کالا را وارد کنید'}
                      onChange={(e) => handleInputChange('length', e.target.value)}
                  />
              </div>
              <div>
                  <InputField
                      label={'ارتفاع (سانتی متر)'}
                      name={'ProductHeight'}
                      type={'number'}
                      value={productData.height ? Number(productData.height) : ''}
                      placeholder={'ارتفاع کالا را وارد کنید'}
                      onChange={(e) => handleInputChange('height', e.target.value)}
                  />
              </div>
              <div>
                  <InputField
                      label={'وزن (کیلوگرم)'}
                      name={'ProductWeight'}
                      type={'number'}
                      value={productData.weight ? Number(productData.weight) : ''}
                      placeholder={'وزن کالا را وارد کنید'}
                      onChange={(e) => handleInputChange('weight', e.target.value)}
                  />
              </div>
              <div className='flex flex-col'>
                  <label
                      htmlFor={'unit_of_measure'}
                      className="text-sm font-medium text-gray-700 mb-2"
                  >
                      واحد اندازه‌گیری
                  </label>
                  <select
                      name={'unit_of_measure'}
                      value={productData.unit_of_measure}
                      onChange={(e) => handleInputChange('unit_of_measure', e.target.value)}
                      className='border rounded-lg p-2.5 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#1E3A5F] transition-all'
                  >
                      {UNIT_CHOICES.map((option) => (<option key={option.value} value={option.value}>
                              {option.label}
                          </option>
                      ))}
                  </select>

              </div>
              <ToggleField
                  title="قابل بسته‌بندی"
                  checked={productData.is_packable}
                  fieldKey="is_packable"
                  onChange={handleToggleChange}
              />
              <ToggleField
                  title="شکستنی"
                  checked={productData.is_fragile}
                  fieldKey="is_fragile"
                  onChange={handleToggleChange}
              />
              <ToggleField
                  title="اشتعال پذیر"
                  checked={productData.is_flammable}
                  fieldKey="is_flammable"
                  onChange={handleToggleChange}
              />
              <ToggleField
                  title="مایعات"
                  checked={productData.is_liquid}
                  fieldKey="is_liquid"
                  onChange={handleToggleChange}
              />
              <ToggleField
                  title="خورنده"
                  checked={productData.is_corrosive}
                  fieldKey="is_corrosive"
                  onChange={handleToggleChange}
              />

          </div>
      </div>

  );
};

export default ProductBasicInfo;